import { proxy } from 'valtio'
import { devtools } from 'valtio/utils'
import { type ApiCallType } from '../types/ApiCallType'
import { type GlobalUserType } from '../types/GlobalUserType'

export interface GlobalUserProxyType {
  isPasswordBannerDismissed: boolean
  isVersionBannerDismissed: boolean
  isVersionBannerDisplayed: boolean
  apiCall: ApiCallType
  user: GlobalUserType | null
}

const initialValues = {
  apiCall: {
    error: null,
    loading: false
  },
  isPasswordBannerDismissed: false,
  isVersionBannerDismissed: false,
  isVersionBannerDisplayed: false,
  user: null
}

export const globalUserProxy = proxy<GlobalUserProxyType>(initialValues)
devtools(globalUserProxy, { name: 'globalUser' })
